const DEF_FONT = {
  fontFamily: 'Arial',
  fontSize: 14,
  fontColor: '000000',
  bold: false,
  italic: false,
  underline: false,
};

const DEF_ALIGN = {
  align: 'left',
  valign: 'top',
};

module.exports = {
  text: {
    ...DEF_FONT,
    ...DEF_ALIGN,
    type: 'text',
    subType: 'none',
    height: 18,
    required: false,
    allowEditing: null,
    viewMode: 'stretch',
    // master: false, // ???
    arrangement: 'none',
    initial: '',
    maxLines: 0,
    maxChars: 0,
    hint: '',
    color: '000000',
  },
  checkmark: {
    type: 'checkmark',
    subType: '_x',
    color: '000000',
    // master: false,
    radioGroup: '',
    required: false,
    hint: '',
    initial: '0',
    allowEditing: null,
  },
  radio: {
    type: 'radio',
    subType: '_x',
    color: '000000',
    // master: false,
    radioGroup: '',
    required: false,
    hint: '',
    initial: '0',
    allowEditing: null,
  },
  image: {
    type: 'image',
    subType: 'none',
    required: false,
    hint: '',
    allowEditing: null,
  },
  signature: {
    type: 'signature',
    subType: 'none',
    required: false,
    hint: '',
    allowEditing: null,
  },
};
